import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useIsMobile, Stack, Text, Link, Button } from '@hub-la/design-system';
import { useTranslation, Trans } from 'react-i18next';
import { getGroupUrl, getAppUrl, getPayUrl } from '../../utils/routes.js';
import { Wrapper } from './paywall.styled.js';

const Paywall = props => {
  const {
    productName,
    groupId
  } = props;
  const {
    t
  } = useTranslation();
  const isMobile = useIsMobile();
  return jsxs(Wrapper, Object.assign({
    direction: ['column', 'row'],
    padding: 6
  }, {
    children: [jsx(Stack, Object.assign({
      marginBottom: [6, 0],
      marginRight: [0, 12],
      flex: 1
    }, {
      children: jsx(Text, Object.assign({
        color: "onBackground"
      }, {
        children: jsx(Trans, {
          i18nKey: 'postDetail.paywall.title',
          values: {
            name: productName
          },
          components: [jsx("b", {}), jsx(Link, {
            href: getGroupUrl(groupId)
          })]
        })
      }))
    })), jsxs(Stack, Object.assign({
      direction: ['column-reverse', 'row'],
      spacing: 2,
      height: ['auto', 48],
      width: ['100%', 'auto']
    }, {
      children: [jsx(Link, Object.assign({
        href: getAppUrl(`/auth?redirectTo=${window.location.href}`)
      }, {
        children: jsx(Button, Object.assign({
          fullWidth: isMobile,
          variant: "text",
          marginTop: [2, 0],
          marginRight: [0, 2]
        }, {
          children: t('postDetail.paywall.alreadyMember')
        }))
      })), jsx(Link, Object.assign({
        href: getPayUrl(`/${groupId}`)
      }, {
        children: jsx(Button, Object.assign({
          fullWidth: isMobile,
          variant: "filled",
          hierarchy: "primary"
        }, {
          children: t('postDetail.paywall.purchase')
        }))
      }))]
    }))]
  }));
};

export { Paywall };
